// deps
import React, { memo, ReactElement, useCallback, useContext } from "react";
import { useEffectOnce } from "@swiggy-private/core-ui";

// internal deps
import { SuccessBsWithRedirect } from "@swiggy-private/payment-ui";
import {
    AnalyticsContext,
    CheckoutActionTypes,
    CheckoutContext,
    getBridgeSdk,
    PayOnDeliveryPaymentAlreadyDoneActionPayload,
} from "@swiggy-private/checkout-core";
import {
    NavigateToScreenRequestPayload,
    NavigationScreenLinkTypes,
    NavigationTypes,
} from "@swiggy-private/native-bridge";

// contexts
import { PaymentPayContext } from "@payment-client/contexts/PaymentPayContext";
import { paymentAlreadyDoneImpressionEvent } from "@payment-client/analytics/events/OrderInterruption";

function PaymentAlreadyDoneAlert(props: {
    payload: PayOnDeliveryPaymentAlreadyDoneActionPayload;
}): ReactElement | null {
    const { checkoutState } = useContext(CheckoutContext);
    const { interruptData } = props.payload;
    const { impressionEvent } = useContext(AnalyticsContext);
    const { billTotal } = useContext(PaymentPayContext);

    useEffectOnce(() => {
        if (checkoutState.type === CheckoutActionTypes.PAY_ON_DELIVERY_PAYMENT_ALREADY_DONE) {
            paymentAlreadyDoneImpressionEvent(impressionEvent, billTotal);
        }
    });

    const openTrackScreen = useCallback(() => {
        if (interruptData?.orderId) {
            const data: NavigateToScreenRequestPayload = {
                type: NavigationTypes.SCREEN,
                link: NavigationScreenLinkTypes.TRACK,
                params: {
                    orderId: interruptData.orderId,
                    hideMakePaymentButton: true, // tell native to hide the make payment button for autopay
                    shouldCloseWebview: true,
                },
            };

            getBridgeSdk()
                .navigateToScreen(data)
                .catch(() => void 0);
        }
    }, [interruptData]);

    if (checkoutState.type !== CheckoutActionTypes.PAY_ON_DELIVERY_PAYMENT_ALREADY_DONE) {
        return null;
    }

    return (
        <SuccessBsWithRedirect onClose={openTrackScreen} title={interruptData.title} durationInSec={3} hideCloseIcon />
    );
}

export default memo(PaymentAlreadyDoneAlert);
